import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Clock, Rocket, Sparkles } from 'lucide-react';

const FlashSaleTimer = ({ endTime = null, discount = 20 }) => {
  const { pathname } = useLocation();
  // LAUNCH DAY: 48 hour sale
  const [targetTime] = useState(() => {
    if (endTime) return new Date(endTime).getTime();
    return Date.now() + 48 * 60 * 60 * 1000; // 48 hours for launch
  });
  
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = targetTime - Date.now();
      
      if (difference > 0) {
        setTimeLeft({
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24) + Math.floor(difference / (1000 * 60 * 60 * 24)) * 24,
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [targetTime]);

  const formatNumber = (num) => String(num).padStart(2, '0');

  if (typeof window !== 'undefined' && window.location.pathname.startsWith('/admin/packing-slip')) {
    return null;
  }
  if (pathname === '/' || pathname === '/voyage' || pathname === '/selah' || pathname === '/library') {
    return null;
  }

  return (
    <div className="print:hidden bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500 text-white py-3 px-4" data-testid="flash-sale-timer">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-4 flex-wrap">
        <div className="flex items-center gap-2">
          <Rocket className="h-5 w-5 animate-bounce" />
          <span className="font-bold text-lg">GRAND LAUNCH</span>
          <Sparkles className="h-4 w-4 animate-pulse" />
          <span className="bg-white/20 px-2 py-0.5 rounded text-sm font-semibold">
            {discount}% OFF EVERYTHING
          </span>
        </div>
        
        <div className="flex items-center gap-2">
          <Clock className="h-4 w-4" />
          <span className="text-sm">Launch special ends:</span>
          <div className="flex items-center gap-1 font-mono font-bold">
            <div className="bg-white/20 rounded px-2 py-1">
              {formatNumber(timeLeft.hours)}
            </div>
            <span>:</span>
            <div className="bg-white/20 rounded px-2 py-1">
              {formatNumber(timeLeft.minutes)}
            </div>
            <span>:</span>
            <div className="bg-white/20 rounded px-2 py-1">
              {formatNumber(timeLeft.seconds)}
            </div>
          </div>
        </div>
        
        <span className="text-sm hidden sm:inline">Use code: <strong className="bg-white/30 px-2 py-0.5 rounded">SELAH20</strong></span>
      </div>
    </div>
  );
};

export default FlashSaleTimer;
